var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExlamCircleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ffc13d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1525.083 -2428.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 12,
    rx: 6,
    transform: "translate(-1523.083 2430.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16Zm-.006-5.3a1.138,1.138,0,0,0-.8.319,1.093,1.093,0,0,0-.237.346,1.069,1.069,0,0,0-.086.429,1.086,1.086,0,0,0,.323.78,1.075,1.075,0,0,0,.355.23,1.181,1.181,0,0,0,.448.084,1.164,1.164,0,0,0,.442-.084,1.112,1.112,0,0,0,.358-.23,1.053,1.053,0,0,0,.239-.348A1.088,1.088,0,0,0,9.12,11.8a1.061,1.061,0,0,0-.326-.775,1.183,1.183,0,0,0-.358-.233A1.132,1.132,0,0,0,7.994,10.7ZM7.085,3.475V7.136A9.745,9.745,0,0,0,7.155,8.3c.046.383.109.781.186,1.181H8.685c.076-.4.139-.8.185-1.181a9.745,9.745,0,0,0,.07-1.168V3.475Z",
    transform: "translate(-1525.083 2428.917)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExlamCircleYellow);
export default __webpack_public_path__ + "static/media/exlam-circle-yellow.a2a8fc553c319938d754b0b978214c28.svg";
export { ForwardRef as ReactComponent };